import { supabase } from '../supabase';

/**
 * Verify the user's age
 * @returns True if the verification was successful
 */
export async function verifyUserAge(): Promise<boolean> {
  try {
    // Call the RPC function to verify the user's age
    const { data, error } = await supabase.rpc('verify_user_age', { p_verified: true });
    
    if (error) throw error;
    
    // Update user metadata to include age verification status
    const { error: updateError } = await supabase.auth.updateUser({
      data: { age_verified: true }
    });
    
    if (updateError) throw updateError;
    
    return true;
  } catch (error) {
    console.error('Error verifying age:', error);
    throw error;
  }
}

/**
 * Check if the user's age is verified
 * @returns True if the user's age is verified
 */
export async function isAgeVerified(): Promise<boolean> {
  try {
    // First check user metadata
    const { data: { user } } = await supabase.auth.getUser();
    if (user?.user_metadata?.age_verified) {
      return true;
    }
    
    // Then check the profile record
    const { data: profile, error } = await supabase
      .from('profiles')
      .select('age_verified')
      .eq('user_id', user?.id)
      .single();
    
    if (error) throw error;
    
    return profile?.age_verified || false;
  } catch (error) {
    console.error('Error checking age verification:', error);
    return false;
  }
}